import React from 'react';
import { CTAButton } from './CTAButton';
import { blueprints, tools } from '../data/content';
export function Blueprints() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-69" data-mp="36moq5tsr6xjr">
      <div className="mx-auto max-w-5xl" data-id="element-70" data-mp="31oeuzj713wy5">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-71" data-mp="31n3ohbm78b3c">
          📦 What you’ll find inside{' '}
          <span className="text-brand-600" data-id="element-72" data-mp="3ue3u1r06hmx4">The Natural Veneer Blueprint™</span>
        </h2>

        <ol className="mt-9 space-y-4" data-id="element-73" data-mp="3pe95vv7sfbfr">
          {blueprints.map(bp => <li key={bp.roman} className="rounded-3xl border border-brand-100 bg-white p-5 shadow-soft sm:flex sm:gap-6 sm:p-7" data-id="element-74" data-mp="3kfo0lhdoi1kg">
              <div className="flex items-center gap-3 sm:w-40 sm:shrink-0 sm:flex-col sm:items-start sm:gap-2" data-id="element-75" data-mp="3gdt4qseioge2">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-700 font-display text-lg font-bold text-white" data-id="element-76" data-mp="28y66zaptaibn">
                  {bp.roman}
                </span>
                <span className="text-[11px] font-extrabold uppercase tracking-[0.12em] text-brand-600" data-id="element-77" data-mp="1tmea98lf3l25">
                  Blueprint {bp.roman}
                </span>
              </div>

              <div className="mt-4 sm:mt-0 sm:flex-1" data-id="element-78" data-mp="1knj2hs2q62wq">
                <h3 className="font-display text-[20px] font-bold leading-tight text-ink sm:text-2xl" data-id="element-79" data-mp="1oomeg3hnjeso">
                  {bp.title}
                </h3>
                <p className="mt-2.5 text-[14.5px] leading-relaxed text-brand-900/75" data-id="element-80" data-mp="1avwjvao251jy">{bp.text}</p>
                {bp.bullets ? <ul className="mt-4 flex flex-wrap gap-2" data-id="element-81" data-mp="110bklkadifdw">
                    {bp.bullets.map(bullet => <li key={bullet} className="rounded-lg bg-brand-50 px-2.5 py-1.5 text-[12px] font-bold text-brand-700" data-id="element-82" data-mp="15y4sqiv8ljgt">
                        {bullet}
                      </li>)}
                  </ul> : null}
              </div>
            </li>)}
        </ol>

        <h3 className="mt-14 text-center font-display text-[24px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-83" data-mp="2tw5ifqnm6yyt">
          📲 You’ll also get immediate access to:
        </h3>

        <ul className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-84" data-mp="2kvz82dn7qf3v">
          {tools.map(tool => <li key={tool.title} className="flex h-full flex-col rounded-2xl border border-brand-100 bg-white p-5" data-id="element-85" data-mp="3hmrpbelvud78">
              <span className="text-2xl" aria-hidden="true" data-id="element-86" data-mp="3cl2cbtf3npgi">
                {tool.emoji}
              </span>
              <h4 className="mt-3 text-[15.5px] font-bold leading-snug text-ink" data-id="element-87" data-mp="38nedifaadcjc">{tool.title}</h4>
              <p className="mt-2 text-[13.5px] leading-relaxed text-brand-900/70" data-id="element-88" data-mp="33otcidn7motu">{tool.text}</p>
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-brand-200 bg-white p-6 sm:p-9" data-id="element-89" data-mp="1s721v8wa08rh">
          <h3 className="text-center font-display text-[22px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-90" data-mp="7psvbp7g3d9m">
            Whatever veneer case walks into your practice…
          </h3>
          <p className="mt-3 text-center text-[14.5px] text-brand-900/70" data-id="element-91" data-mp="gpz6h4fo815m">
            You’ll have a visual system to help you answer:
          </p>
          <ul className="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-2.5 sm:grid-cols-2" data-id="element-92" data-mp="lhh4pkqb7nmw">
            {['“What am I seeing?”', '“What should I be trying to achieve?”', '“Which variable is causing the problem?”', '“What should I check before I continue?”'].map(q => <li key={q} className="rounded-xl bg-brand-50 px-4 py-3 text-center font-display text-[15px] font-bold text-brand-700" data-id="element-93" data-mp="10c3r8mk3wq03">
                {q}
              </li>)}
          </ul>

          <div className="mx-auto mt-8 max-w-xl" data-id="element-94" data-mp="367y7cmedc2vb">
            <CTAButton label="Get access to the complete system" note="$27 USD · Instant access · Lifetime access" data-id="element-95" data-mp="2awq7ju14om27" />
          </div>
        </div>
      </div>
    </section>;
}